import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '@environments/environment';
import { getFeatureFlagBypassToken, resolveBrandDomain } from './feature-flag-bypass.helper';

function parse(url: string): URL | null {
  try {
    return new URL(url);
  } catch {
    return null;
  }
}

/** True only when `requestUrl` is on the API's exact origin and under its path. */
export function isMemberPortalApiUrl(requestUrl: string): boolean {
  const resolved = resolveBrandDomain(environment.memberPortalServiceURL);
  // An empty or unresolved base must match nothing.
  if (!resolved || resolved.includes('{{')) {
    return false;
  }
  const base = parse(resolved);
  const target = parse(requestUrl);
  if (!base || !target || base.origin === 'null' || target.origin !== base.origin) {
    return false;
  }
  const basePath = base.pathname.replace(/\/+$/, '');
  return target.pathname === basePath || target.pathname.startsWith(`${basePath}/`);
}

/**
 * Feature Flag Bypass Token Interceptor
 *
 * Adds the bypass_token query parameter to requests destined for the member portal API,
 * enabling testers to bypass feature flags without turning them on globally.
 *
 * - The API base is resolved like the services do (brandDomain placeholder -> window.location.host)
 * - The request must match its origin exactly plus a path-segment boundary; an empty or
 *   unparsable base matches nothing
 * - External services (MX, third parties) never receive the token
 * - Works for both public (IS_PUBLIC) and authenticated requests
 */
export const featureFlagBypassInterceptor: HttpInterceptorFn = (req, next) => {
  const token = getFeatureFlagBypassToken();

  if (token && isMemberPortalApiUrl(req.url)) {
    req = req.clone({ setParams: { bypass_token: token } });
  }

  return next(req);
};
